import { FileText } from "lucide-react";
import { formatDateTime } from "../../utils";
import type { CsvAttachment, ImageAttachment } from "./types";

type UserMessageBubbleProps = {
  content?: string;
  images?: ImageAttachment[];
  csvs?: CsvAttachment[];
  createdAt?: string;
};

function ImageAttachments({ images = [] }: { images?: ImageAttachment[] }) {
  if (images.length === 0) return null;

  return (
    <div className="flex flex-wrap justify-end gap-1.5">
      {images.map((image, index) => (
        <img
          key={index}
          src={image.dataUrl}
          alt=""
          className="h-32 max-w-[200px] rounded-xl object-cover shadow-sm"
        />
      ))}
    </div>
  );
}

function CsvAttachments({ csvs = [] }: { csvs?: CsvAttachment[] }) {
  if (csvs.length === 0) return null;

  return (
    <div className="flex flex-wrap justify-end gap-1.5">
      {csvs.map((csv, index) => (
        <div
          key={index}
          className="flex items-center gap-1.5 rounded-lg border border-green-200 bg-green-50 px-2.5 py-1 text-xs text-green-800"
        >
          <FileText size={11} className="text-green-600" />
          <span className="max-w-[160px] truncate font-medium">
            {csv.filename}
          </span>
        </div>
      ))}
    </div>
  );
}

export default function UserMessageBubble({
  content,
  images,
  csvs,
  createdAt,
}: UserMessageBubbleProps) {
  return (
    <div className="flex justify-end">
      <div className="max-w-[85%] space-y-1.5 md:max-w-[60%]">
        <ImageAttachments images={images} />
        <CsvAttachments csvs={csvs} />

        {content && (
          <div className="rounded-2xl bg-blue-600 px-4 py-2.5 text-sm text-white shadow-sm">
            {content}
          </div>
        )}

        {createdAt && (
          <time
            dateTime={createdAt}
            className="block pr-1 text-right text-[10px] text-gray-400"
          >
            {formatDateTime(createdAt)}
          </time>
        )}
      </div>
    </div>
  );
}
